// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host([label-position=inline-start]) .ids-input,
:host([label-position=inline-start]) .ids-textarea {
  display: flex;
  align-items: var(--ids-label-align-y, center);
}
:host([label-position=inline-start]) .ids-input label,
:host([label-position=inline-start]) .ids-textarea label {
  width: var(--ids-label-width);
  padding-block: var(--ids-label-padding-block);
  padding-inline-end: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-input .validation-message,
:host([label-position=inline-start]) .ids-textarea .validation-message {
  width: 100%;
  margin-block-start: var(--ids-space-2xs);
}
@media (max-width: 927px) {
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    margin-inline-start: 0;
  }
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
    margin-block-end: 0;
  }
}
@container (width > \$breakpoint-xs) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
    margin-block-end: 0;
  }
}
@media (min-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea {
    flex-wrap: wrap;
    gap: 8px;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label {
    flex: 0 0 auto;
    margin-bottom: unset;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-input .field-container,
  :host([label-position=inline-start]) .ids-textarea .field-container {
    order: 2;
  }
  :host([label-position=inline-start]) .ids-input .textarea-field-group,
  :host([label-position=inline-start]) .ids-textarea .textarea-field-group {
    order: 2;
    flex: 1 1 auto;
    min-width: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    flex: 1 1 100%;
    min-width: 100%;
    order: 3;
    margin-block-start: calc(0px - var(--ids-space-2xs));
    margin-inline-start: calc(var(--ids-label-width) + 6px);
  }
}
:host([label-position=inline-start]) .ids-checkbox {
  margin-top: var(--ids-space-00);
}
@media (min-width: 320px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
  :host([label-position=inline-start]) .ids-checkbox.label-state-collapsed .validation-message {
    margin-inline-start: unset;
  }
}
@container (min-width: 320px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}

:host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
  container-type: normal;
}
@media (width <= 320px) {
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}

:host([label-position=inline-start][label-alignment=end]) .ids-input,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea {
  gap: var(--ids-label-alignment-gap);
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
  display: inline-flex;
  align-items: var(--ids-label-align-y, center);
  justify-content: flex-end;
  text-align: end;
}
@container (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
  position: relative;
}
@media (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
    text-align: start;
    align-self: start;
  }
}
@container (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
    text-align: start;
    align-self: start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
  margin-inline-end: 0;
  position: absolute;
  margin-top: unset;
  inset-inline-end: -5px;
  top: 7px;
}
@container (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
    position: initial;
    margin-top: unset;
    inset-inline-end: initial;
  }
}
@media (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
    position: initial;
    margin-top: unset;
    inset-inline-end: initial;
  }
}
:host([label-position=inline-start][label-alignment=end]) .field-container {
  flex: 1;
}
:host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
  text-align: end;
  padding-inline-end: 0;
}
@media (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
    text-align: start;
  }
}
@container (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
    text-align: start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-checkbox label.required .label-checkbox span::after {
  margin-inline-end: 0;
  position: absolute;
  margin-top: unset;
  right: -5px;
  top: -5px;
}
@media (width > 767px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    text-align: end;
  }
  @container (width < 320px) {
    :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
      justify-content: flex-start;
    }
  }
}
@media (width > 767px) and (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-radio-group ids-text.group-label-text {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-radio-group ids-text.group-label-text {
    justify-content: flex-start;
  }
}

:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-input label,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-textarea label,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-textarea .ids-label-text {
  display: none;
}

:host([label-position=inline-start][label-alignment=end][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-alignment=end][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  column-gap: var(--ids-label-alignment-gap);
}

:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea {
  display: flex;
  flex-wrap: nowrap;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea label {
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host(.in-flex-item[label-position=inline-start]) .ids-input,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  display: grid;
  gap: 0;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: var(--ids-label-alignment-gap);
}
:host(.in-flex-item[label-position=inline-start]) .ids-input label,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea label {
  grid-column: 1;
  grid-row: 1;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input .field-container,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .field-container {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input .validation-message,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .validation-message {
  grid-column: 1/-1;
  grid-row: 2;
  width: auto;
  margin-inline-start: 0;
  margin-block-start: var(--ids-space-2xs);
}
:host(.in-flex-item[label-position=inline-start]) .ids-input.wrapped .validation-message,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.wrapped .validation-message {
  grid-column: 2;
  margin-inline-start: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input.sm, :host(.in-flex-item[label-position=inline-start]) .ids-input.mm, :host(.in-flex-item[label-position=inline-start]) .ids-input.md, :host(.in-flex-item[label-position=inline-start]) .ids-input.lg,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.sm,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.mm,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.md,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.lg,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.sm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.mm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.md,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.lg,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.sm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.mm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.md,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.lg {
  grid-template-columns: auto minmax(0, 1fr);
}

:host(.in-flex-item[label-position=inline-start]) .ids-input label {
  max-height: var(--ids-label-max-height-inline-start);
}
:host(.in-flex-item[label-position=inline-start]) .ids-checkbox input[type=checkbox] ~ .checkmark {
  inset-inline-end: 0;
  margin-inline-end: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-radio-group ids-text.group-label-text {
  margin-top: 0;
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@container (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    display: block;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    gap: 0;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    flex-wrap: wrap;
  }
}

@media (width <= 320px) {
  :host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea {
    display: block;
    gap: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label {
    min-height: auto;
    margin-bottom: var(--ids-input-margin-bottom);
  }
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@container (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}

:host([label-position=inline-start][label-break=break]) .ids-input,
:host([label-position=inline-start][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-start][label-break=break]) .ids-input label,
:host([label-position=inline-start][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=break]) .ids-input .field-container,
:host([label-position=inline-start][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=break]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host([label-position=inline-start][label-width="0px"]) .ids-label-text,
:host([label-position=inline-start][label-width="0"]) .ids-label-text {
  display: none;
}

:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text {
  overflow: visible;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text.required {
  padding-inline-end: 0;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text.required::after {
  inset-inline-end: -7px;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea.wrapped .validation-message {
  margin-inline-start: calc(var(--ids-label-width) + 11px);
}

:host([label-position=inline-end][label-break=shrink-value]) .ids-input,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea {
  display: flex;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input label,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea label {
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input .field-container,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

@media (width > 320px) {
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    justify-content: end;
    flex: 0 1 auto;
    order: 2;
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    order: 1;
  }
}

:host([label-position=inline-end][label-break=break]) .ids-input,
:host([label-position=inline-end][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-end][label-break=break]) .ids-input label,
:host([label-position=inline-end][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=break]) .ids-input .field-container,
:host([label-position=inline-end][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-end][label-break=break]) .ids-textarea .validation-message {
  margin-inline-start: 0;
  order: 3;
}
:host([label-position=inline-end][label-break=break]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start]) {
  --ids-label-width: var(--ids-label-width-inline-start);
}

:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea label {
  align-self: var(--ids-label-align-y, center);
}
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea .ids-label-text {
  overflow: visible;
}

@media (width > 767px) {
  :host([label-position=inline-start]:not([label-break=shrink-value]):not([size=full])) .ids-textarea {
    max-width: calc(370px + var(--ids-label-width));
  }
  :host([label-position=inline-start]:not([label-break=shrink-value]):not([size=full])) .ids-textarea .textarea-field {
    width: calc(370px + var(--ids-label-width));
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-filter-field label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-filter-field #operator-button {
    position: relative;
    inset-inline-start: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    width: 100%;
    margin-block-start: var(--ids-space-2xs);
  }
}
@media (width < 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: inherit;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-inline-start: initial;
  }
}

@media (min-width: 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    right: initial;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-block-start: 0;
  }
}
:host([label-position=inline-start]) .ids-radio-group.label-inline,
:host([label-position=inline-end]) .ids-radio-group.label-inline {
  display: flex;
  align-items: var(--ids-label-align-y, flex-start);
  gap: var(--ids-space-2, 0.5rem);
}
:host([label-position=inline-start]) .ids-radio-group.label-inline ids-text.group-label-text,
:host([label-position=inline-end]) .ids-radio-group.label-inline ids-text.group-label-text {
  min-width: var(--ids-label-width);
  margin-top: calc(var(--ids-space-xs) - 2px);
}
:host([label-position=inline-start]) .ids-radio-group.label-inline slot,
:host([label-position=inline-end]) .ids-radio-group.label-inline slot {
  display: flex;
  flex-direction: column;
}

:host([label-position=inline-end]) .ids-radio-group.label-inline ids-text.group-label-text {
  justify-content: end;
  order: 2;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline slot {
  order: 1;
}

:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked {
  display: flex;
  align-items: var(--ids-label-align-y, baseline);
  gap: var(--ids-space-2, 0.5rem);
  flex-direction: column;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked ids-text.group-label-text {
  min-width: var(--ids-label-width);
  order: 2;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked slot {
  display: flex;
  flex-direction: column;
  order: 1;
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-switch {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-switch label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    padding-inline-start: 0;
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-switch input[type=checkbox] ~ .slider {
    left: unset;
    right: -45px;
  }
  :host([label-position=inline-start][label-state=collapsed]) .ids-switch label {
    padding-inline-end: 0;
    width: 0;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-switch input[type=checkbox] ~ .slider {
    left: -45px;
    right: initial;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-data-label {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-data-label .label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    margin-block-end: 0;
    white-space: nowrap;
  }
  :host([label-position=inline-start]) .ids-data-label .data,
  :host([label-position=inline-start]) .ids-data-label .description {
    display: flex;
    padding-block: var(--ids-label-padding-block);
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
:host([label-state=collapsed]) {
  --ids-label-width: 0;
  width: fit-content;
}

:host(ids-checkbox[label-state=collapsed]) {
  width: fit-content;
  display: block;
}

@container (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start][label-state=hidden]) .ids-input .ids-label-text {
    display: none;
  }
}

@container (max-width: 320px) {
  :host([label-position=inline-start][label-state=hidden]) .ids-input .ids-label-text {
    display: none;
  }
}
:host .ids-input label,
:host .ids-input .label,
:host .ids-textarea label,
:host .ids-textarea .label,
:host .ids-checkbox label,
:host .ids-checkbox .label,
:host .ids-radio label,
:host .ids-radio .label,
:host .ids-switch label,
:host .ids-switch .label,
:host .ids-data-label label,
:host .ids-data-label .label,
:host .ids-filter-field label,
:host .ids-filter-field .label {
  width: var(--ids-label-width);
}

:host([label-position=inline-start][label-state=collapsed]) .ids-radio-group ids-text.group-label-text,
:host([label-position=inline-end][label-state=collapsed]) .ids-radio-group ids-text.group-label-text {
  display: none;
}

:host([label-position=inline-start][label-state=hidden]) .ids-radio-group ids-text.group-label-text,
:host([label-position=inline-end][label-state=hidden]) .ids-radio-group ids-text.group-label-text {
  visibility: hidden;
}

/* Ids Lookup Component */
.data-grid-container {
  overflow: hidden;
  position: relative;
  max-height: 400px;
}

@media (max-width: 767px) {
  ids-layout-grid {
    --min-col-width: 0 !important;
  }
  .data-grid-container.has-search {
    max-height: calc(100dvh - 184px);
  }
  .data-grid-container {
    max-height: 100%;
    height: 100%;
  }
  .data-grid-parent-container {
    height: 100% !important;
  }
}
.data-grid-parent-container {
  overflow: auto;
}

ids-trigger-field::part(clearable-button) {
  margin-inline-end: -9px;
}

ids-trigger-field[compact]::part(clearable-button) {
  margin-inline-end: -2px;
}

.result-count {
  font-size: var(--ids-lookup-result-count-font-size);
  margin: var(--ids-lookup-result-count-margin);
  vertical-align: middle;
}

ids-trigger-button[slot=trigger-end] {
  margin-inline-start: 4px;
}`, "",{"version":3,"sources":["webpack://./src/themes/mixins/ids-label-position-mixin.scss","webpack://./src/components/ids-lookup/ids-lookup.scss"],"names":[],"mappings":"AAKE;;EAEE,aAAA;EACA,6CAAA;ACJJ;ADOI;;EACE,6BAAA;EACA,6CAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;ACJN;ADQI;;EACE,WAAA;EACA,wCAAA;ACLN;ADOM;EAJF;;IAKI,sBAAA;ECHN;AACF;ADOM;EADF;;IAEI,oBAAA;IACA,mBAAA;ECHN;AACF;ADKM;EANF;;IAOI,oBAAA;IACA,mBAAA;ECDN;AACF;ADII;EApCF;;IAqCI,eAAA;IACA,QAAA;ECAJ;EDEI;;IACE,cAAA;IACA,oBAAA;IACA,QAAA;ECCN;EDEI;;IACE,QAAA;ECCN;EDEI;;IACE,QAAA;IACA,cAAA;IACA,YAAA;ECCN;EDEI;;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,oDAAA;IAMA,uDAAA;ECJN;AACF;ADQE;EACE,+BAAA;ACNJ;ADSE;EACE;IACE,aAAA;IACA,eAAA;IACA,6CAAA;ECPJ;EDUI;IACE,aAAA;IACA,mBAAA;IACA,WAAA;IACA,6CAAA;IACA,sBAAA;IACA,wBAAA;ECRN;EDWI;IACE,6BAAA;IACA,cAAA;ECTN;EDYI;IACE,kBAAA;IACA,oBAAA;ECVN;EDaI;IACE,OAAA;ECXN;EDcI;IACE,WAAA;IACA,uEAAA;IACA,wCAAA;ECZN;EDgBM;IACE,0BAAA;ECdR;AACF;ADmBE;EACE;IACE,aAAA;IACA,eAAA;IACA,6CAAA;ECjBJ;EDoBI;IACE,aAAA;IACA,mBAAA;IACA,WAAA;IACA,6CAAA;IACA,sBAAA;IACA,wBAAA;EClBN;EDqBI;IACE,6BAAA;IACA,cAAA;ECnBN;EDsBI;IACE,kBAAA;IACA,oBAAA;ECpBN;EDuBI;IACE,OAAA;ECrBN;EDwBI;IACE,WAAA;IACA,uEAAA;IACA,wCAAA;ECtBN;AACF;;AD6BE;EACE,sBAAA;AC1BJ;AD4BI;EAHF;IAII,aAAA;IACA,eAAA;IACA,6CAAA;ECzBJ;ED2BI;IACE,aAAA;IACA,mBAAA;IACA,WAAA;IACA,6CAAA;IACA,uDAAA;IACA,sBAAA;IACA,wBAAA;ECzBN;ED4BI;IACE,6BAAA;IACA,cAAA;EC1BN;ED6BI;IACE,kBAAA;IACA,oBAAA;EC3BN;ED8BI;IACE,OAAA;EC5BN;ED+BI;IACE,WAAA;IACA,uEAAA;IACA,wCAAA;EC7BN;AACF;;ADmCE;;EAEE,mCAAA;AChCJ;ADkCI;;;;EAEE,oBAAA;EACA,6CAAA;EACA,yBAAA;EACA,eAAA;AC9BN;ADgCM;EAPF;;;;IAQI,2BAAA;EC1BN;AACF;ADiBI;;;;EAWE,kBAAA;ACtBN;AD6BM;EAlBF;;;;IAmBI,2BAAA;IACA,iBAAA;IACA,iBAAA;ECvBN;AACF;ADyBM;EAxBF;;;;IAyBI,2BAAA;IACA,iBAAA;IACA,iBAAA;ECnBN;AACF;ADsBQ;;;;EACE,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,QAAA;ACjBV;ADoBU;EARF;;;;IASI,iBAAA;IACA,iBAAA;IACA,yBAAA;ECdV;AACF;ADiBU;EAfF;;;;IAgBI,iBAAA;IACA,iBAAA;IACA,yBAAA;ECXV;AACF;ADiBE;EACE,OAAA;ACfJ;ADmBI;EACE,eAAA;EACA,qBAAA;ACjBN;ADmBM;EAJF;IAKI,iBAAA;EChBN;AACF;ADkBM;EARF;IASI,iBAAA;ECfN;AACF;ADkBQ;EACE,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;AChBV;ADuBE;EAEI;IACE,oBAAA;IACA,mBAAA;IACA,yBAAA;IACA,eAAA;ECtBN;EDwBM;IANF;MAOI,2BAAA;ICrBN;EACF;AACF;ADsBQ;EAVF;IAWI,2BAAA;ECnBR;AACF;AD0BI;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;ACxBN;AD4BE;EAEI;IACE,2BAAA;EC3BN;AACF;;ADqCI;;;;EAEE,aAAA;AChCN;;ADsCE;;EAEE,0CAAA;ACnCJ;;AD0CE;;;;EAEE,aAAA;EACA,iBAAA;ACrCJ;ADuCI;;;;EACE,cAAA;AClCN;ADqCI;;;;EACE,YAAA;EACA,cAAA;AChCN;ADoCI;;;;EACE,WAAA;EACA,sBAAA;AC/BN;;ADuCE;;;;EAEE,aAAA;EACA,MAAA;EACA,0CAAA;EACA,0CAAA;AClCJ;ADoCI;;;;EACE,cAAA;EACA,WAAA;AC/BN;ADkCI;;;;EACE,cAAA;EACA,WAAA;EACA,YAAA;AC7BN;ADgCI;;;;EACE,iBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,wCAAA;AC3BN;AD8BI;;;;EACE,cAAA;EACA,sBAAA;ACzBN;AD4BI;;;;;;;;;;;;;EACE,0CAAA;ACdN;;ADoBE;EACE,oDAAA;ACjBJ;ADqBI;EACE,mBAAA;EACA,oBAAA;ACnBN;ADyBM;EACE,aAAA;ACvBR;;AD8BE;EACE;IACE,aAAA;IACA,+CAAA;EC3BJ;ED6BI;IACE,6BAAA;IACA,cAAA;EC3BN;ED8BI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EC5BN;AACF;ADgCE;EACE;IACE,aAAA;IACA,+CAAA;EC9BJ;EDgCI;IACE,6BAAA;IACA,cAAA;EC9BN;EDiCI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EC/BN;AACF;ADmCE;EACE;;IAEE,cAAA;ECjCJ;EDoCE;IACE,MAAA;EClCJ;AACF;ADqCE;EACE;;;IAGE,eAAA;ECnCJ;AACF;;ADwCE;EACE;IACE,cAAA;IACA,MAAA;ECrCJ;EDuCI;IACE,gBAAA;IACA,6CAAA;ECrCN;AACF;;AD2CE;EACE;IACE,aAAA;IACA,+CAAA;ECxCJ;ED0CI;IACE,6BAAA;IACA,cAAA;ECxCN;ED2CI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;ECzCN;AACF;AD6CG;EACC;IACE,aAAA;IACA,+CAAA;EC3CJ;ED6CI;IACE,6BAAA;IACA,cAAA;EC3CN;ED8CI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EC5CN;AACF;;ADkDE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AC/CJ;ADiDI;;EACE,WAAA;EACA,cAAA;AC9CN;ADiDI;;EACE,YAAA;EACA,cAAA;AC9CN;ADkDI;;EACE,WAAA;EACA,sBAAA;AC/CN;;ADuDE;;EACE,aAAA;ACnDJ;;AD2DI;;;;EACE,iBAAA;ACrDN;ADuDM;;;;EACE,qBAAA;AClDR;ADoDQ;;;;EACE,sBAAA;AC/CV;ADoDI;;;;EACE,wDAAA;AC/CN;;ADuDE;;EAEE,aAAA;ACpDJ;ADsDI;;EACE,cAAA;EACA,QAAA;ACnDN;ADsDI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;ACnDN;ADuDE;EACE,+BAAA;ACrDJ;;AD0DE;EACE;IACE,aAAA;IACA,+CAAA;ECvDJ;EDyDI;IACE,6BAAA;IACA,oBAAA;IACA,cAAA;IACA,QAAA;ECvDN;ED0DI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;IACA,QAAA;ECxDN;AACF;;AD8DE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AC3DJ;AD6DI;;EACE,WAAA;EACA,cAAA;EACA,QAAA;AC1DN;AD6DI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;AC1DN;AD8DI;;EACE,sBAAA;EACA,QAAA;AC3DN;AD+DE;EACE,+BAAA;AC7DJ;;ADiEA;EACE,sDAAA;AC9DF;;ADuEI;;;;EACE,4CAAA;ACjEN;ADoEI;;;;EACE,iBAAA;AC/DN;;ADqEA;EAEI;IACE,+CAAA;ECnEJ;EDqEI;IACE,2CAAA;ECnEN;AACF;ADyEA;EAEI;IACE,aAAA;IACA,eAAA;IACA,+CAAA;ECxEJ;ED0EI;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,sBAAA;ECxEN;ED4EI;IACE,kBAAA;IACA,0CAAA;EC1EN;ED8EI;IACE,WAAA;IACA,wCAAA;EC5EN;AACF;ADmFE;EAEI;IACE,4CAAA;EClFN;EDqFI;IACE,4BAAA;ECnFN;AACF;;ADwFA;EAEI;IACE,cAAA;ECtFJ;EDyFE;IACE,qBAAA;ECvFJ;AACF;ADiGA;;EAEE,aAAA;EACA,iDAAA;EACA,+BAAA;AC/FF;ADiGE;;EACE,iCAAA;EACA,2CAAA;AC9FJ;ADiGE;;EACE,aAAA;EACA,sBAAA;AC9FJ;;ADmGE;EACE,oBAAA;EACA,QAAA;AChGJ;ADmGE;EACE,QAAA;ACjGJ;;ADsGA;EACE,aAAA;EACA,+CAAA;EACA,+BAAA;EACA,sBAAA;ACnGF;ADqGE;EACE,iCAAA;EACA,QAAA;ACnGJ;ADsGE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ACpGJ;;ADyGA;EACE;IACE,aAAA;IACA,eAAA;IACA,+CAAA;ECtGF;EDwGE;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,uBAAA;IACA,sBAAA;ECtGJ;EDyGE;IACE,WAAA;IACA,YAAA;ECvGJ;ED2GA;IACE,qBAAA;IACA,QAAA;ECzGF;ED6GE;IACE,WAAA;IACA,cAAA;EC3GJ;AACF;ADgHA;EACE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,+CAAA;EC9GF;EDgHE;IACE,6BAAA;IACA,6CAAA;IACA,sBAAA;IACA,mBAAA;IACA,mBAAA;EC9GJ;EDiHE;;IAEE,aAAA;IACA,6CAAA;EC/GJ;AACF;ADoHA;EAEI;;;IAGE,aAAA;IACA,sBAAA;IACA,kBAAA;ECnHJ;EDqHI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ECjHN;EDoHI;;;IACE,sBAAA;EChHN;EDsHE;;;IAGE,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,+BAAA;ECpHJ;EDsHI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;EClHN;EDqHI;;;IACE,sBAAA;ECjHN;AACF;ADsHA;EACE,oBAAA;EAEA,kBAAA;ACrHF;;ADwHA;EACE,kBAAA;EACA,cAAA;ACrHF;;ADwHA;EAEI;;;IAGE,aAAA;IACA,sBAAA;IACA,kBAAA;ECtHJ;EDwHI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ECpHN;EDuHI;;;IACE,sBAAA;ECnHN;EDyHE;;;IAGE,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,+BAAA;ECvHJ;EDyHI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ECrHN;EDwHI;;;IACE,sBAAA;ECpHN;AACF;AD0HE;EACE;IACE,aAAA;ECxHJ;AACF;;AD4HA;EAEI;IACE,aAAA;EC1HJ;AACF;ADuII;;;;;;;;;;;;;;EAEE,6BAAA;ACzHN;;ADkIE;;EACE,aAAA;AC9HJ;;ADoIE;;EACE,kBAAA;AChIJ;;AA73BA,yBAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AAg4BF;;AA73BA;EACE;IAEE,6BAAA;EA+3BF;EA53BA;IACE,gCAAA;EA83BF;EA33BA;IACE,gBAAA;IACA,YAAA;EA63BF;EA13BA;IACE,uBAAA;EA43BF;AACF;AAz3BA;EACE,cAAA;AA23BF;;AAx3BA;EACE,uBAAA;AA23BF;;AAx3BA;EACE,uBAAA;AA23BF;;AAx3BA;EACE,mDAAA;EACA,6CAAA;EACA,sBAAA;AA23BF;;AAx3BA;EACE,wBAAA;AA23BF","sourcesContent":["// Label position styles\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Left aligned and Right Aligned Labels\n:host([label-position='inline-start']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    align-items: var(--ids-label-align-y, center);\n\n    // Adjust the label\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: 0;\n      box-sizing: border-box;\n      flex-shrink: 0;\n    }\n\n    // Validation on the bottom\n    .validation-message {\n      width: 100%;\n      margin-block-start: var(--ids-space-2xs);\n\n      @media (max-width: $breakpoint-md) {\n        margin-inline-start: 0;\n      }\n    }\n\n    .ids-label-text {\n      @media (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n        margin-block-end: 0;\n      }\n\n      @container (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n        margin-block-end: 0;\n      }\n    }\n\n    @media (min-width: $breakpoint-xs) {\n      flex-wrap: wrap;\n      gap: 8px;\n\n      label {\n        flex: 0 0 auto;\n        margin-bottom: unset;\n        order: 1;\n      }\n\n      .field-container {\n        order: 2;\n      }\n\n      .textarea-field-group {\n        order: 2;\n        flex: 1 1 auto;\n        min-width: 0;\n      }\n\n      .validation-message {\n        flex: 1 1 100%;\n        min-width: 100%;\n        order: 3;\n        margin-block-start: calc(0px - var(--ids-space-2xs));\n\n        // Label and field sit side-by-side at this breakpoint, so the wrapped\n        // message below must indent to the field start. Applied unconditionally\n        // (not only via the JS `.wrapped` class) so alignment is deterministic\n        // and not subject to ResizeObserver timing.\n        margin-inline-start: calc(var(--ids-label-width) + 6px);\n      }\n    }\n  }\n\n  .ids-checkbox {\n    margin-top: var(--ids-space-00);\n  }\n\n  @media (min-width: #{$breakpoint-xs}) {\n    .ids-checkbox {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, center);\n\n      // Adjust the label\n      label {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding-block: var(--ids-label-padding-block);\n        box-sizing: border-box;\n        gap: var(--ids-space-xs);\n      }\n\n      .label-checkbox {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      .checkbox-wrapper {\n        position: relative;\n        display: inline-flex;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));\n        margin-block-start: var(--ids-space-2xs);\n      }\n\n      &.label-state-collapsed {\n        .validation-message {\n          margin-inline-start: unset;\n        }\n      }\n    }\n  }\n\n  @container (min-width: #{$breakpoint-xs}) {\n    .ids-checkbox {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, center);\n\n      // Adjust the label\n      label {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding-block: var(--ids-label-padding-block);\n        box-sizing: border-box;\n        gap: var(--ids-space-xs);\n      }\n\n      .label-checkbox {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      .checkbox-wrapper {\n        position: relative;\n        display: inline-flex;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n// Horizontal aligned: use viewport media query instead of container query\n:host([label-position='inline-start'][horizontal-aligned]) {\n  .ids-checkbox {\n    container-type: normal;\n\n    @media (width <= $breakpoint-xs) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, center);\n\n      label {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n        gap: var(--ids-space-xs);\n      }\n\n      .label-checkbox {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      .checkbox-wrapper {\n        position: relative;\n        display: inline-flex;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"]) {\n  .ids-input,\n  .ids-textarea {\n    gap: var(--ids-label-alignment-gap);\n\n    label,\n    .ids-label-text {\n      display: inline-flex;\n      align-items: var(--ids-label-align-y, center);\n      justify-content: flex-end;\n      text-align: end;\n\n      @container (width <= #{$breakpoint-xs}) {\n        justify-content: flex-start;\n      }\n\n      position: relative;\n\n      // At/under the xs breakpoint the label stacks on top of the field, so the\n      // end alignment (right-aligned, full label width) must reset to start.\n      // Kept in sync with the stacking rule below (`max-width: $breakpoint-xs`)\n      // so the boundary at exactly $breakpoint-xs doesn't leave the label\n      // right-aligned and overflowing the field.\n      @media (width <= $breakpoint-xs) {\n        justify-content: flex-start;\n        text-align: start;\n        align-self: start;\n      }\n\n      @container (width <= #{$breakpoint-xs}) {\n        justify-content: flex-start;\n        text-align: start;\n        align-self: start;\n      }\n\n      &.required {\n        &::after {\n          margin-inline-end: 0;\n          position: absolute;\n          margin-top: unset;\n          inset-inline-end: -5px;\n          top: 7px;\n\n          // stylelint-disable-next-line\n          @container (width <= #{$breakpoint-xs}) {\n            position: initial;\n            margin-top: unset;\n            inset-inline-end: initial;\n          }\n\n          // stylelint-disable-next-line\n          @media (width <= $breakpoint-xs) {\n            position: initial;\n            margin-top: unset;\n            inset-inline-end: initial;\n          }\n        }\n      }\n    }\n  }\n\n  .field-container {\n    flex: 1;\n  }\n\n  .ids-checkbox {\n    label {\n      text-align: end;\n      padding-inline-end: 0;\n\n      @media (width <= $breakpoint-xs) {\n        text-align: start;\n      }\n\n      @container (width <= #{$breakpoint-xs}) {\n        text-align: start;\n      }\n\n      &.required .label-checkbox span {\n        &::after {\n          margin-inline-end: 0;\n          position: absolute;\n          margin-top: unset;\n          right: -5px;\n          top: -5px;\n        }\n      }\n    }\n  }\n\n  // Switch label-alignment end\n  @media (width > $breakpoint-sm) {\n    .ids-switch {\n      label {\n        display: inline-flex;\n        align-items: center;\n        justify-content: flex-end;\n        text-align: end;\n\n        @container (width < #{$breakpoint-xs}) {\n          justify-content: flex-start;\n        }\n\n        @media (width < $breakpoint-xs) {\n          justify-content: flex-start;\n        }\n      }\n    }\n  }\n\n  // Radio group label-alignment end\n  .ids-radio-group {\n    ids-text.group-label-text {\n      display: inline-flex;\n      align-items: center;\n      justify-content: flex-end;\n    }\n  }\n\n  @container (width < #{$breakpoint-xs}) {\n    .ids-radio-group {\n      ids-text.group-label-text {\n        justify-content: flex-start;\n      }\n    }\n  }\n}\n\n// When the label is collapsed, remove it from the input/textarea layout so the\n// end-aligned label does not reserve space.\n:host([label-position='inline-start'][label-alignment][label-state='collapsed']) {\n  .ids-input,\n  .ids-textarea {\n    label,\n    .ids-label-text {\n      display: none;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"][label-break='shrink-value'][validation-message-count]:not([error-tracker])) {\n  .ids-input,\n  .ids-textarea {\n    column-gap: var(--ids-label-alignment-gap);\n  }\n}\n\n// Label break behavior for inline-start position\n:host([label-position='inline-start'][label-break='shrink-value']:not([validation-message-count])),\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count][error-tracker]) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-wrap: nowrap;\n\n    label {\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n// When validation is present with shrink-value, use grid to keep field width stable\n:host(.in-flex-item[label-position='inline-start']),\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count]:not([error-tracker])) {\n  .ids-input,\n  .ids-textarea {\n    display: grid;\n    gap: 0;\n    grid-template-columns: auto minmax(0, 1fr);\n    column-gap: var(--ids-label-alignment-gap);\n\n    label {\n      grid-column: 1;\n      grid-row: 1;\n    }\n\n    .field-container {\n      grid-column: 2;\n      grid-row: 1;\n      min-width: 0;\n    }\n\n    .validation-message {\n      grid-column: 1 / -1;\n      grid-row: 2;\n      width: auto;\n      margin-inline-start: 0;\n      margin-block-start: var(--ids-space-2xs);\n    }\n\n    &.wrapped .validation-message {\n      grid-column: 2;\n      margin-inline-start: 0;\n    }\n\n    &.sm, &.mm, &.md, &.lg {\n      grid-template-columns: auto minmax(0, 1fr);\n    }\n  }\n}\n\n:host(.in-flex-item[label-position='inline-start']) {\n  .ids-input label {\n    max-height: var(--ids-label-max-height-inline-start);\n  }\n\n  .ids-checkbox {\n    input[type='checkbox'] ~ .checkmark {\n      inset-inline-end: 0;\n      margin-inline-end: 0;\n    }\n  }\n\n  .ids-radio-group {\n    ids-text {\n      &.group-label-text {\n        margin-top: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-value']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @container (width > #{$breakpoint-xs}) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @media (width < $breakpoint-xs) {\n    .ids-input,\n    .ids-textarea {\n      display: block;\n    }\n\n    .ids-textarea {\n      gap: 0;\n    }\n  }\n\n  @container (width < #{$breakpoint-xs}) {\n    .ids-input,\n    .ids-textarea,\n    .ids-radio-group {\n      flex-wrap: wrap;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-value']:not([validation-message-count])) {\n  @media (width <= $breakpoint-xs) {\n    .ids-textarea {\n      display: block;\n      gap: 0;\n\n      label {\n        min-height: auto;\n        margin-bottom: var(--ids-input-margin-bottom);\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex: 0 1 auto;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n   @container (width > #{$breakpoint-xs}) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex: 0 1 auto;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-width=\"0px\"]),\n:host([label-position='inline-start'][label-width=\"0\"]) {\n  // When a label is \"inline-start\" and `label-width=\"0px\"` simply don't display it\n  .ids-label-text {\n    display: none;\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"][label-wrap=\"ellipsis-no-stretch\"]),\n:host([label-position='inline-start'][label-alignment=\"end\"][label-wrap=\"ellipsis\"]) {\n  .ids-input,\n  .ids-textarea {\n    .ids-label-text {\n      overflow: visible;\n\n      &.required {\n        padding-inline-end: 0;\n\n        &::after {\n          inset-inline-end: -7px;\n        }\n      }\n    }\n\n    &.wrapped .validation-message {\n      margin-inline-start: calc(var(--ids-label-width) + 11px);\n    }\n  }\n}\n\n\n// Label break behavior for inline-end position\n:host([label-position='inline-end'][label-break='shrink-value']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n\n    label {\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position='inline-end'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        justify-content: end;\n        flex: 0 1 auto;\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n        order: 1;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-end'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      margin-inline-start: 0;\n      order: 3;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position=\"inline-start\"]) {\n  --ids-label-width: var(--ids-label-width-inline-start);\n}\n\n// When label-wrap constrains the label size, ensure it stays vertically centered\n// instead of stretching to fill the flex container height\n:host([label-position=\"inline-start\"][label-wrap=\"ellipsis-no-stretch\"]),\n:host([label-position=\"inline-start\"][label-wrap=\"wrap-no-stretch\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      align-self: var(--ids-label-align-y, center);\n    }\n\n    .ids-label-text {\n      overflow: visible;\n    }\n  }\n}\n\n// Text area\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']:not([label-break='shrink-value']):not([size='full'])) {\n    .ids-textarea {\n      max-width: calc(370px + var(--ids-label-width));\n\n      .textarea-field {\n        width: calc(370px + var(--ids-label-width));\n      }\n    }\n  }\n}\n\n// Filter field\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-filter-field {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        width: var(--ids-label-width);\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      // Filter field specific rules\n      #operator-button {\n        position: relative;\n        inset-inline-start: var(--ids-label-width);\n      }\n\n      // Validation on the bottom\n      .validation-message {\n        width: 100%;\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n// Checkboxes\n:host([label-position='inline-start'][dir='rtl']) {\n  @media (width < $breakpoint-sm) {\n    .ids-checkbox {\n      label {\n        --ids-checkbox-padding-inline-start: inherit;\n      }\n\n      .validation-message {\n        margin-inline-start: initial;\n      }\n    }\n  }\n}\n\n@media (min-width: $breakpoint-sm) {\n  :host([label-position='inline-start'][dir='rtl']) .ids-checkbox {\n    input[type='checkbox'] ~ .checkmark {\n      right: initial;\n    }\n\n    .validation-message {\n      margin-block-start: 0;\n    }\n  }\n}\n\n\n// Radio buttons\n// The inline (side) label layout is toggled by `onLabelPositionChange` in\n// ids-radio-group via the `label-inline` / `label-inline-end-stacked` classes,\n// which are driven by the group's own width. This lets the layout respond to\n// its container rather than the viewport.\n:host([label-position='inline-start']) .ids-radio-group.label-inline,\n:host([label-position='inline-end']) .ids-radio-group.label-inline {\n  display: flex;\n  align-items: var(--ids-label-align-y, flex-start);\n  gap: var(--ids-space-2, 0.5rem);\n\n  ids-text.group-label-text {\n    min-width: var(--ids-label-width);\n    margin-top: calc(var(--ids-space-xs) - 2px);\n  }\n\n  slot {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n:host([label-position='inline-end']) .ids-radio-group.label-inline {\n  ids-text.group-label-text {\n    justify-content: end;\n    order: 2;\n  }\n\n  slot {\n    order: 1;\n  }\n}\n\n// Narrow `inline-end`: stack with the label beneath the options\n:host([label-position='inline-end']) .ids-radio-group.label-inline-end-stacked {\n  display: flex;\n  align-items: var(--ids-label-align-y, baseline);\n  gap: var(--ids-space-2, 0.5rem);\n  flex-direction: column;\n\n  ids-text.group-label-text {\n    min-width: var(--ids-label-width);\n    order: 2;\n  }\n\n  slot {\n    display: flex;\n    flex-direction: column;\n    order: 1;\n  }\n}\n\n// Switch\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-switch {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: var(--ids-label-align-y, baseline);\n\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: var(--ids-label-padding-inline-end);\n      padding-inline-start: 0;\n      box-sizing: border-box;\n    }\n\n    input[type='checkbox'] ~ .slider {\n      left: unset;\n      right: -45px;\n    }\n  }\n\n  :host([label-position=\"inline-start\"][label-state=\"collapsed\"]) .ids-switch label {\n    padding-inline-end: 0;\n    width: 0;\n  }\n\n  :host([label-position='inline-start'][dir='rtl']) .ids-switch {\n    input[type='checkbox'] ~ .slider {\n      left: -45px;\n      right: initial;\n    }\n  }\n}\n\n// Data Label\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-data-label {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: var(--ids-label-align-y, baseline);\n\n    .label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      box-sizing: border-box;\n      margin-block-end: 0;\n      white-space: nowrap;\n    }\n\n    .data,\n    .description {\n      display: flex;\n      padding-block: var(--ids-label-padding-block);\n    }\n  }\n}\n\n// Responsive behavior\n@media (max-width: $breakpoint-xs) {\n  :host([label-position=\"inline-start\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: flex;\n      flex-direction: column;\n      align-items: unset;\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n\n  :host([label-position=\"inline-end\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: flex;\n      flex-direction: column;\n      align-items: unset;\n      gap: var(--ids-space-2, 0.5rem);\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n}\n\n:host([label-state=\"collapsed\"]) {\n  --ids-label-width: 0;\n\n  width: fit-content;\n}\n\n:host(ids-checkbox[label-state=\"collapsed\"]) {\n  width: fit-content;\n  display: block;\n}\n\n@container (max-width: #{$breakpoint-xs}) {\n  :host([label-position=\"inline-start\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: flex;\n      flex-direction: column;\n      align-items: unset;\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n\n  :host([label-position=\"inline-end\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: flex;\n      flex-direction: column;\n      align-items: unset;\n      gap: var(--ids-space-2, 0.5rem);\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-state=\"hidden\"]) {\n  @media (max-width: $breakpoint-xs) {\n    .ids-input .ids-label-text {\n      display: none;\n    }\n  }\n}\n\n@container (max-width: #{$breakpoint-xs}) {\n  :host([label-position='inline-start'][label-state=\"hidden\"]) {\n    .ids-input .ids-label-text {\n      display: none;\n    }\n  }\n}\n\n// Just the label width\n:host {\n  .ids-input,\n  .ids-textarea,\n  .ids-checkbox,\n  .ids-radio,\n  .ids-switch,\n  .ids-data-label,\n  .ids-filter-field {\n    label,\n    .label {\n      width: var(--ids-label-width);\n    }\n  }\n}\n\n// Declared last so label-state wins over label-alignment/label-break/label-wrap,\n// keeping the radio group label hidden regardless of the other layout attributes.\n:host([label-position='inline-start'][label-state='collapsed']),\n:host([label-position='inline-end'][label-state='collapsed']) {\n  .ids-radio-group ids-text.group-label-text {\n    display: none;\n  }\n}\n\n:host([label-position='inline-start'][label-state='hidden']),\n:host([label-position='inline-end'][label-state='hidden']) {\n  .ids-radio-group ids-text.group-label-text {\n    visibility: hidden;\n  }\n}\n","@use '../../themes/mixins/ids-core-mixins' as *;\n@use '../../themes/mixins/ids-label-position-mixin.scss' as label-position;\n\n/* Ids Lookup Component */\n.data-grid-container {\n  overflow: hidden;\n  position: relative;\n  max-height: 400px;\n}\n\n@media (max-width: $breakpoint-sm) {\n  ids-layout-grid {\n    // Need important to override inline element styles\n    --min-col-width: 0 !important;\n  }\n\n  .data-grid-container.has-search {\n    max-height: calc(100dvh - 184px);\n  }\n\n  .data-grid-container {\n    max-height: 100%;\n    height: 100%;\n  }\n\n  .data-grid-parent-container  {\n    height: 100% !important;\n  }\n}\n\n.data-grid-parent-container {\n  overflow: auto;\n}\n\nids-trigger-field::part(clearable-button) {\n  margin-inline-end: -9px;\n}\n\nids-trigger-field[compact]::part(clearable-button) {\n  margin-inline-end: -2px;\n}\n\n.result-count {\n  font-size: var(--ids-lookup-result-count-font-size);\n  margin: var(--ids-lookup-result-count-margin);\n  vertical-align: middle;\n}\n\nids-trigger-button[slot=\"trigger-end\"] {\n  margin-inline-start: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
